import  {request} from "./request";

export function getWords(word) {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/pattern/'+word,
        params:{
        }
    })

}
export function getNewWords() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/new/10',
        withCredentials:true,
        params:{
        }
    })

}
export function getDateWords(date) {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/date/'+date,
        withCredentials:true,
        params:{
        }
    })

}
export function getReviewWords() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/review/1',
        params:{
        }
    })

}
export function clockWords(id) {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/clockNew/'+id,
        params:{
        }
    })

}
export function wordLogin(username,password) {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/login',
        method:'POST',
        // withCredentials:true,
        params:{
            username:username,
            password:password,
        }
    })

}

export function wordLoginOut() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/out',
        params:{
        }
    })

}

export function recoverWord() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/recover/1',
        params:{
        }
    })

}
export function planWord() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/plan/1',
        params:{
        }
    })

}
export function allPlanWord() {
    return request({
        //url:'/home/multidata',
        url:'/servlet_word1/plans/1',
        params:{
        }
    })

}
